// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-3S5h1"};